import DefaultIntegration from './DefaultIntegration/DefaultIntegration'
import { seelIntegrationType } from './SeelIntegration/constants'
import SeelIntegration from './SeelIntegration/SeelIntegration'

const IntegrationDetailBody = ({ integration, storeId, onChange, hasChanges, onRevertChanges, onSave }) => {
  if (integration?.type === seelIntegrationType) {
    return (
      <SeelIntegration
        integration={integration}
        storeId={storeId}
        onChange={onChange}
        hasChanges={hasChanges}
        onRevertChanges={onRevertChanges}
        onSave={onSave}
      />
    )
  }

  return (
    <DefaultIntegration
      integration={integration}
      onChange={onChange}
      hasChanges={hasChanges}
      onRevertChanges={onRevertChanges}
      onSave={onSave}
    />
  )
}

export default IntegrationDetailBody
